<div class="flash-messages"
     *ngIf="hasMessages()">
    <app-flash-messages-for context="danger"></app-flash-messages-for>
    <app-flash-messages-for context="warning"></app-flash-messages-for>
    <app-flash-messages-for context="success"></app-flash-messages-for>
    <app-flash-messages-for context="info"></app-flash-messages-for>
</div>
